// extracted by mini-css-extract-plugin
module.exports = {"modal":"_FyeM","title":"_3FFwB","description":"_1AyfC","cross":"wBiTs","modalBackDrop":"_5HZdp","content":"_3mG3q","mobileImage":"_3fMum"};